import { ObjectHelpers } from "../../helpers/object-helpers";


export interface EMACloudSettings {
    displayBuySellFlags: boolean;
    displayOnlyLastTwoTrades: boolean;
    sectionCount: number;
}

export class EMACloudSettingsModel {
    public displayBuySellFlags = true;
    public displayOnlyLastTwoTrades = true;
    public items: Array<EMACloudSettingModel> = [];

    constructor(settings: EMACloudSettings) {
        this.displayBuySellFlags = settings.displayBuySellFlags;
        this.displayOnlyLastTwoTrades = settings.displayOnlyLastTwoTrades;
        
        const sectionCount = settings.sectionCount;
        if (!this.items?.length) {
            this.items = [];
            if (sectionCount == 1) {
                let maTypeValue = 'EMA';
                let fastValue = 8;
                let slowValue = 9;
                let upColorValue = '#074a07';
                let downColorValue = '#7b0c20';
                let opacityValue = 72;
                this.items.push(new EMACloudSettingModel({ maType: maTypeValue, fast: fastValue, slow: slowValue, upColor: upColorValue, downColor: downColorValue, opacity: opacityValue }));
            }

            if (sectionCount == 2) {
                let maTypeValue = 'EMA';
                let fastValue = 8;
                let slowValue = 9;
                let upColorValue = '#074a07';
                let downColorValue = '#7b0c20';
                let opacityValue = 72;
                this.items.push(new EMACloudSettingModel({ maType: maTypeValue, fast: fastValue, slow: slowValue, upColor: upColorValue, downColor: downColorValue, opacity: opacityValue }));

                maTypeValue = 'EMA';
                fastValue = 5;
                slowValue = 12;
                upColorValue = '#006598';
                downColorValue = '#F88605';
                opacityValue = 38;
                this.items.push(new EMACloudSettingModel({ maType: maTypeValue, fast: fastValue, slow: slowValue, upColor: upColorValue, downColor: downColorValue, opacity: opacityValue }));
            }

            if (sectionCount == 3) {
                let maTypeValue = 'EMA';
                let fastValue = 8;
                let slowValue = 9;
                let upColorValue = '#9fc5e8';
                let downColorValue = '#f9cb9c';
                let opacityValue = 70;
                this.items.push(new EMACloudSettingModel({ maType: maTypeValue, fast: fastValue, slow: slowValue, upColor: upColorValue, downColor: downColorValue, opacity: opacityValue }));

                maTypeValue = 'EMA';
                fastValue = 5;
                slowValue = 12;
                upColorValue = '#006598';
                downColorValue = '#F88605';
                opacityValue = 90;
                this.items.push(new EMACloudSettingModel({ maType: maTypeValue, fast: fastValue, slow: slowValue, upColor: upColorValue, downColor: downColorValue, opacity: opacityValue }));

                maTypeValue = 'EMA';
                fastValue = 34;
                slowValue = 50;
                upColorValue = '#267cc0';
                downColorValue = '#c48d3c';
                opacityValue = 46;
                this.items.push(new EMACloudSettingModel({ active: false, maType: maTypeValue, fast: fastValue, slow: slowValue, upColor: upColorValue, downColor: downColorValue, opacity: opacityValue }));
            }
        }
    }
}

export class EMACloudSettingModel {
    public active = true;
    public maType = 'EMA';
    public fast = 8;
    public slow = 21;
    public upColor = 'rgb(0, 255, 0)';
    public downColor = 'rgb(255, 0, 0)';
    public opacity = 70;

    constructor(data?: any) {
        if (data) ObjectHelpers.setProperties(data, this, true);
    }

    public static makeList(items: any): Array<EMACloudSettingModel> {
        const result: Array<EMACloudSettingModel> = [];
        if (items?.length) {
            for (const i of items) {
                result.push(new EMACloudSettingModel(i));
            }
        }

        return result;
    }

    public getFastObjectKey(): string {
        return `${this.maType}${this.fast}CLOSE`.toLowerCase();
    }

    public getSlowObjectKey(): string {
        return `${this.maType}${this.slow}CLOSE`.toLowerCase();
    }

    public getFastGridRequestKey(): string {
        return `${this.maType} ${this.fast} CLOSE`;
    }

    public getSlowGridRequestKey(): string {
        return `${this.maType} ${this.slow} CLOSE`;
    }
}